import { jwtDecode } from "jwt-decode"

export const getPhoneFromToken = () => {
  const token = localStorage.getItem('authToken')
  if (!token) return null

  try {
    const decoded = jwtDecode(token)
    return decoded?.min || null
  } catch (error) {
    console.error('Error decoding JWT:', error)
    return null
  }
}
